import { z } from 'zod';
import { OVERVIEW_VIEWS } from './constants';

export const overviewViewSearchParam = z.enum(OVERVIEW_VIEWS).optional().catch(undefined);
